import React from 'react';
import { Formik, Form, Field, } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as dataSeed from '../shared/DataSeed';
import * as Yup from "yup";
import { Persist } from 'formik-persist';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, FormFeedback
} from 'reactstrap';

export let defaultValue = {
    nik: '',
    fullname: '',
    dob: '',
    pob: '',
    gender: '',
    bank: '',
    code: ''
}
const valAlphaOnly = /^[a-zA-Z .,]+$/;
const valAlphaNumeric = /^[a-zA-Z 1234567890]+$/;
const valAlphaNumericSpecial = /^[a-zA-Z 1234567890.,\-']+$/;
const nonFirstZero = /^[1-9].*/;
const numericOnly = /^[0-9]*$/;
const dobMax = '2010-01-01';

class DukcapilValidation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imageHash: '',//Date.now(),
            daftar: false, // localStorage.getItem('dukcapil.daftar') || false,
            valid: false,
            openMessage: false,
            dataRegister: null,
            pilihBank: localStorage.getItem('pilihBank') || '',
            KTP: localStorage.getItem('KTP')
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.pendaftaranClick = this.pendaftaranClick.bind(this);
        this.reloadCaptcha = this.reloadCaptcha.bind(this);
    }

    async onSubmit(values, { setFieldValue }) {
        console.log('onSubmit...');
        try {
            //values.bank = this.state.pilihBank;
            //values.norek = localStorage.getItem('norek') || '';

            //console.log('values.bank', values.bank);
            //if (values.bank === '') {
            //    values.norek = this.props.defaultValue2.BankAccountNumber2;
            //    values.bank = this.props.defaultValue2.BankCode2;
            //}

            const token = localStorage.getItem('verificationToken');

            const url = `api/validation/personal`;
            const res = await fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(values)
            });
            const data = await res.json();

            if (data.ResponseCode === '00') {
                this.setState({ valid: true, openMessage: true });
            } else {
                if (data.ResponseCode != null){
                    alert('Gagal [' + data.ResponseCode + ']: ' + data.Message);
                } else {
                    let errorDetails = '';
                    if (data.errors) {
                        for (const key in data.errors) {
                            errorDetails += '\n- ' + data.errors[key].join(', ');
                        }
                    }
                    alert('Gagal [error]: ' + (data.title || 'Validasi gagal') + errorDetails);
                }
                this.setState({ imageHash: Date.now(), dataRegister: { ...this.state.dataRegister, code: '' } });
                setFieldValue('code', '');
            }
            await this.setState({ dataRegister: values });
        } catch (err) {
             console.log(err);
        }

    }

    reloadCaptcha = () => {
        this.setState(({ imageHash: Date.now() }));
    };

    pendaftaranClick(values, setFieldValue) {
        // eslint-disable-next-line no-restricted-globals
        let result = confirm("Dengan ini, saya menyatakan bahwa seluruh data yang sudah dan yang akan saya isi dalam pembukaan rekening secara elektronik ini adalah benar adanya dan dengan penuh tanggung jawab yang kemudian dapat dikelola oleh PT Yakin Bertumbuh Sekuritas");
        if (result === true) {
            //this.props.nowRegister(this.state.dataRegister);
            this.props.nowRegister(values, setFieldValue);
            this.setState({ daftar: true, openMessage: false });
            //localStorage.setItem('dukcapil.daftar', true);
        }
    }

    ValidationSchema = Yup.object().shape({
        nik: Yup.string().required('NIK harus diisi').matches(numericOnly, 'Hanya dapat diisi dengan angka').matches(nonFirstZero, 'Angka pertama tidak boleh 0').min(16, 'NIK harus 16 karakter').max(16, 'NIK harus 16 karakter'), //.min(1000000000000000, 'NIK harus 16 digit').max(9999999999999999, 'NIK harus 16 digit'),
        fullname: Yup.string().required('Nama Lengkap harus diisi').matches(valAlphaOnly, 'Nama Lengkap hanya boleh huruf').min(3, 'Nama Lengkap minimal 3 huruf'),
        pob: Yup.string().required('Tempat Lahir harus diisi').matches(valAlphaNumericSpecial, 'Tempat Lahir hanya boleh angka dan huruf').min(3, 'Tempat Lahir minimal 3 huruf'),
        dob: Yup.date().required('Tgl Lahir harus diisi').max(new Date(dobMax), 'Pilih tanggal yang lebih kecil'),
        //code: Yup.string().required('Harus diisi').min(4, 'Minimal 4 huruf').matches(valAlphaNumeric, 'Hanya angka dan huruf'),
        gender: Yup.string().required('Jenis Kelamin harus dipilih')
    });

    render() {
        const imageValidation = "/api/register/image-validation";

        const { defaultValue2, touched, errors, isValid, values, setFieldValue } = this.props;

        return (<React.Fragment>
            <UncontrolledAlert color="success" isOpen={this.state.openMessage}>Data berhasil di verfikasi, lanjutkan ke pendaftaran.</UncontrolledAlert>
            {/*<Formik*/}
            {/*    initialValues={{*/}
            {/*        defaultValue2, bank: this.state.pilihBank*/}
            {/*        }}*/}
            {/*    onSubmit={this.onSubmit}*/}
            {/*    validationSchema={this.ValidationSchema}*/}
            {/*>*/}
            {/*    {({ errors, touched, values, isValid, setFieldValue, setFieldTouched, handleSubmit }) => (*/}
                    <Fade in={true}>
                        {/*<Form autoComplete="off" onSubmit={handleSubmit}>*/}
                            <FormGroup tag="fieldset">
                                <legend>Verifikasi Data Pribadi</legend>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>NIK<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="nik" id="nik" bsSize="sm"
                                                invalid={errors.nik && touched.nik} />
                                            {errors.nik ? (
                                                <FormFeedback>{errors.nik}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Nama Lengkap<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="fullname" id="fullname" bsSize="sm"
                                                invalid={errors.fullname && touched.fullname} />
                                            {errors.fullname ? (
                                                <FormFeedback>{errors.fullname}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Tempat Lahir<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="text" name="pob" id="pob" bsSize="sm"
                                                invalid={errors.pob && touched.pob} />
                                            {errors.pob ? (
                                                <FormFeedback>{errors.pob}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Tanggal Lahir<span className="text-danger">*</span></Label>
                                            <Input tag={Field} disabled={this.state.daftar} type="date" name="dob" bsSize="sm"
                                                invalid={errors.dob && touched.dob} />
                                            {errors.dob ? (
                                                <FormFeedback>{errors.dob}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Jenis Kelamin<span className="text-danger">*</span></Label>
                                            <Field className={errors.gender && touched.gender ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                                disabled={this.state.daftar}
                                                component="select" name="gender"
                                                validate={errors.gender && touched.gender}>
                                                <option value="">-- Pilih --</option>
                                                {dataSeed.genders.map((gender, index) =>
                                                    <option value={gender.id} key={index}>{gender.name}</option>
                                                )}
                                            </Field>
                                            {errors.gender && touched.gender ? (
                                                <FormFeedback>{errors.gender}</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {/*{this.state.daftar === false ?*/}
                                {/*    <Row>*/}
                                {/*        <Col md="2" sm="5" xs="6">*/}
                                {/*            <FormGroup>*/}
                                {/*                <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />*/}
                                {/*                <img src={imageValidation + '?' + this.state.imageHash} alt="" />*/}
                                {/*                <Button onClick={() => this.reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>*/}
                                {/*                <Input type="text" disabled={this.state.daftar} name="code" tag={Field} maxLength="4" bsSize="sm"*/}
                                {/*                    invalid={errors.code && touched.code} />*/}
                                {/*                {errors.code ? (*/}
                                {/*                    <FormFeedback>{errors.code}</FormFeedback>*/}
                                {/*                ) : null}*/}
                                {/*            </FormGroup>*/}
                                {/*        </Col>*/}
                                {/*        <Col md="5">*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*    : null}*/}

                                <Row>
                                    <Col md="3">
                                        <FormGroup>
                                            {this.state.daftar === false ?
                                                this.state.valid ?
                                                    <Button type="button" color="primary" onClick={() => this.pendaftaranClick(values, setFieldValue)} className="btn-block" >Pendaftaran</Button>
                                                    :
                                                    <Button type="button" color="primary" onClick={() => this.onSubmit(values, setFieldValue)} className="btn-block" >Verifikasi</Button>
                                                :
                                                null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </FormGroup>
                            {/*<Persist name="dukcapil" />*/}
                        {/*</Form>*/}
                    </Fade>
            {/*    )}*/}
            {/*</Formik>*/}
        </React.Fragment>)
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DukcapilValidation);



// WEBPACK FOOTER //
// ./src/components/DukcapilValidation.js